/**
 * @file App.js
 */

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Breadcrumb } from "./components/Breadcrumb.tsx";
import { Footer } from "./components/Footer.tsx";
import { GoToTopButton } from "./components/GoToTopButton.tsx";
import { Header } from "./components/Header.tsx";
import { Title } from "./components/Title.tsx";
import { SelectItems } from "./SelectItems.tsx";
import { NotFound } from "./components/NotFound.tsx";
import AnasysFrame from "./anasys/AnasysFrame.tsx";
import CmcdFrame from "./cmcd-200/CmcdFrame.tsx";
import GasLogReaderFrame from "./gas-log-reader/GasLogReaderFrame.tsx";
import "./App.css";

/**
 *
 * @returns {JSX.Element} メインコンポーネント
 */
function App() {
  return (
    <Router>
      <div>
        <Header />
        {/* メインエリア ここから */}
        <main>
          <section>
            {/* ヘディングエリア ここから */}
            <div className="p-heading-wrapper">
              <div className="p-heading p-heading--lower">
                <Breadcrumb />
                <Title />
              </div>
            </div>
            {/* ヘディングエリア ここまで */}

            {/* メインコンテンツエリア ここから */}
            <div className="l-main-content">
              <Routes>
                <Route exact path="/" element={<SelectItems />} />
                <Route path="/anasys/*" element={<AnasysFrame />} />
                <Route path="/cmcd-200/*" element={<CmcdFrame />} />
                <Route
                  path="/gas-log-reader/*"
                  element={<GasLogReaderFrame />}
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            {/* メインコンテンツエリア ここまで */}
          </section>
        </main>
        {/* メインエリア ここまで */}

        <Footer />
        <GoToTopButton />
      </div>
    </Router>
  );
}

export default App;
